import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import StoreModules from "../../../Plugins/Store";

export default new Vuex.Store(StoreModules);
